import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=64d7d59d&scoped=true&"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsMenu.vue?vue&type=style&index=0&id=64d7d59d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7d59d",
  null
  
)

export default component.exports